<template>
  <div style="height: 100%">
    <span style="margin-right:250px;font-weight: bold;display: block;width: 100%;height: 10%">告警信息</span>
    <div v-show="alignIcon">
      <i :style="{color: textAlign === 'right' ? '#07e6f8' : '#fff'}"
         @touchstart="alignClick('right')"
         @click="alignClick('right')"
         class="el-icon-s-unfold pointer"
         style="position: absolute;right: 40px;top: 8px;z-index: 999;"></i>
      <i :style="{color: textAlign === 'center' ? '#07e6f8' : '#fff'}"
         @touchstart="alignClick('center')"
         @click="alignClick('center')"
         class="el-icon-s-operation pointer"
         style="position: absolute;right: 70px;top: 8px;z-index: 999;"></i>
      <i :style="{color: textAlign === 'left' ? '#07e6f8' : '#fff'}"
         @touchstart="alignClick('left')"
         @click="alignClick('left')"
         class="el-icon-s-fold pointer"
         style="position: absolute;right: 100px;top: 8px;z-index: 999;"></i>
    </div>
    <vue-seamless-scroll :class-option="classOption" :data="alarmList" style="height: 100%;overflow:hidden;"
                         v-if="alarmList.length > 0">
      <ul>
        <li :key="index" @touchstart="skipAlarm(item)" @click="skipAlarm(item)" class="DataList_top pointer"
            v-for="(item,index) in alarmList">
          <div class="DataList_left">{{ item.msg }}</div>
          <div :style="{color: item.levelColor}" class="level">{{ item.levelName }}</div>
          <div style="color: rgba(255, 255, 255, .5);margin-top: 10px;">{{ item.createTime }}</div>
        </li>
      </ul>
    </vue-seamless-scroll>
    <no-data style="text-align: center;margin-top: 18%" v-else></no-data>
  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import {getAlarmByCommitTimeAsc} from '@/network/alarm-realtime';
import NoData from "@/components/NoData";
import platenLayoutEdit from '@/mixins/platenLayoutEdit'

export default {
  name: "AlarmInfo",
  mixins: [platenLayoutEdit],
  components: {vueSeamlessScroll, NoData},
  props: ['alignIcon', 'textAlign'],
  computed: {
    classOption() {
      return {
        step: 0.3, //数值越大速度滚动越快
        limitMoveNum: 0, //开始无缝滚动的数据量  //this.alarmList.length
        hoverStop: true, //是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, //开启数据实时监控刷新dom
        // singleHeight: 0, //单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, //单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 //单步运动停止的时间(默认值1000ms)
      };
    },
  },
  created() {
    this.getData();
    this.$store.dispatch('addIntervalObj', {'getAlarmInfo:5000': this.getData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getAlarmInfo')
  },
  data() {
    return {
      alarmList: [],
    }
  },
  methods: {
    getData() {
      getAlarmByCommitTimeAsc().then(res => {
        if (res.code === 0) {
          this.alarmList = res.data ? res.data : [];
          this.limitMoveNum = this.alarmList.length
        }
      })
    },
    alignClick(align) {
      this.$emit('changeAlign', align)
    },
    skipAlarm(item) {
      if (this.isPlatenLayoutEditing) return
      this.$emit('skipOverview', item, null)
    }
  }
}
</script>

<style scoped>
.color {
  margin-top: 8px;
  color: rgba(254, 219, 91, .8);
}

li {
  list-style: none;
  margin-top: 40px;
  height: 130px;
  border-bottom: 1px dashed rgba(32, 204, 253, .2);
}
</style>
